import {
  addtoCart,
  autorizeRazorpay,
  connecttoRazorPay,
  createAddress,
  createCategory,
  createclient,
  createColor,
  createDealer,
  createOrder,
  createPayment,
  createProduct,
  createSize,
  deletclient,
  deleteAddress,
  deleteCartItem,
  deleteDealer,
  fileUpload,
  forgotPassowrd,
  getAddress,
  getAdminDshboard,
  getCartList,
  getCategories,
  getClientDashboard,
  getClientList,
  getColor,
  getDealerDashboard,
  getDealerList,
  getInvoices,
  getOrderId,
  getOrders,
  getProductbyId,
  getProducts,
  getSize,
  resetPassword,
  updateAddress,
  updateCart,
  updateclient,
  updateDealer,
  updateOrderStatus,
  updateProduct,
  updateProductStatus,
  usersLogin,
  verifyOtp,

} from './ApiEndPoint'
import { baseApiCall } from './BaseApiCall'


export const ApiUsersLogin = (data: any) => {
  return baseApiCall({
    url: usersLogin,
    method: 'post',
    data
  })
}

export const ApiForgotPassword = (data: any) => {
  return baseApiCall({
    url: forgotPassowrd,
    method: 'post',
    data
  })
}

export const ApiVerifyOtp = (data: any) => {
  return baseApiCall({
    url: verifyOtp,
    method: 'post',
    data
  })
}

export const ApiResetPassword = (data: any) => {
  return baseApiCall({
    url: resetPassword,
    method: 'post',
    data
  })
}




export const ApiGetClientList = (data?: any) => {
  return baseApiCall({
    url: getClientList + data,
    method: 'get',
  })
}
export const ApiCreateClient = (data?: any) => {
  return baseApiCall({
    url: createclient,
    method: 'post',
    data
  })
}
export const ApiUpdateClient = (params?: any, data?: any) => {
  return baseApiCall({
    url: updateclient + params,
    method: 'put',
    data
  })
}
export const ApiDeleteClient = (data?: any) => {
  return baseApiCall({
    url: deletclient + data,
    method: 'delete',
  })
}







export const ApiGetDealerList = (data?: any) => {
  return baseApiCall({
    url: getDealerList + data,
    method: 'get',
  })
}
export const ApiCreateDealer = (data?: any) => {
  return baseApiCall({
    url: createDealer,
    method: 'post',
    data
  })
}
export const ApiUpdateDelear = (params?: any, data?: any) => {
  return baseApiCall({
    url: updateDealer + params,
    method: 'put',
    data
  })
}

export const ApiDeleteDelear = (data?: any) => {
  return baseApiCall({
    url: deleteDealer + data,
    method: 'delete',
  })
}





export const ApiGetProducts = (data?: any) => {
  return baseApiCall({
    url: getProducts + data,
    method: 'get',
  })
}
export const ApiGetProductbyId = (data?: any) => {
  return baseApiCall({
    url: getProductbyId + data,
    method: 'get',
  })
}

export const ApiCreateCategory = (data?:any) => {
  return baseApiCall({
    url: createCategory,
    method: 'post',
    data
  })
}

export const ApiGetCategories = () => {
  return baseApiCall({
    url: getCategories,
    method: 'get',
  })
}

export const ApiUploadFile = (data: any) => {
  return baseApiCall({
    url: fileUpload,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const ApiCreateColors = (data?:any) => {
  return baseApiCall({
    url: createColor,
    method: 'post',
    data
  })
}

export const ApiGetColors = () => {
  return baseApiCall({
    url: getColor,
    method: 'get',
  })
}
export const ApiGetSizes = () => {
  return baseApiCall({
    url: getSize,
    method: 'get',
  })
}

export const ApiCreateSize = (data?:any) => {
  return baseApiCall({
    url: createSize,
    method: 'post',
    data
  })
}

export const ApiUpdateProduct = (params: any, data: any) => {
  return baseApiCall({
    url: updateProduct + params,
    method: 'put',
    data
  })
}

export const ApiCreateProduct = (data: any) => {
  return baseApiCall({
    url: createProduct,
    method: 'post',
    data
  })
}

export const ApiUpdateProductStatus = (data: any) => {
  return baseApiCall({
    url: updateProductStatus + data,
    method: 'delete',
  })
}

export const ApiGetAdminDashboard = (data:any) => {
  return baseApiCall({
    url: getAdminDshboard + data,
    method: 'get',
  })
}

export const ApiGetClientDashboard = (data:any) => {
  return baseApiCall({
    url: getClientDashboard + data,
    method: 'get',
  })
}

export const ApiConnectWithRazorPay = () => {
  return baseApiCall({
    url: connecttoRazorPay,
    method: 'post',
  })
}
export const ApiHandleRazorpayCallback = (data:any) => {
  return baseApiCall({
    url: autorizeRazorpay,
    method: 'post',
    data
  })
}

export const ApiCreateOrder = (data:any)=>{
  return baseApiCall({
    url: createOrder,
    method: 'post',
    data

  })
}
export const ApiGetOrders = (data:any)=>{
  return baseApiCall({
    url: getOrders + data,
    method: 'get',

  })
}
export const ApiGetOrderbyId = (data:any)=>{
  return baseApiCall({
    url: getOrderId + data,
    method: 'get',

  })
}
export const ApiUpdateOrderStatus = (params:any, data:any)=>{
  return baseApiCall({
    url: updateOrderStatus + params,
    method: 'put',
    data
  })
}



export const ApiGetCartList = ()=>{
  return baseApiCall({
    url: getCartList,
    method: 'get',
  })
}

export const ApiAddToCart = (data?:any)=>{
  return baseApiCall({
    url: addtoCart,
    method: 'post',
    data
  })
}

export const ApiUpdateCartItem = (params:any, data:any)=>{
  return baseApiCall({
    url: updateCart + params,
    method: 'put',
    data
  })
}

export const ApiDeleteCartItem = (data:any)=>{
  return baseApiCall({
    url: deleteCartItem + data,
    method: 'delete',
  })
}



export const ApiGetAddress = (data?:any)=>{
  return baseApiCall({
    url: getAddress + data,
    method: 'get',
  })
}

export const ApiCreateAddress = (data:any)=>{
  return baseApiCall({
    url: createAddress,
    method: 'post',
    data
  })
}

export const ApiUpdateAddress = (params:any, data:any)=>{
  return baseApiCall({
    url: updateAddress + params,
    method: 'put',
    data
  })
}

export const ApiDeleteAddress = (data:any)=>{
  return baseApiCall({
    url: deleteAddress + data,
    method: 'delete',
  })
}


export const ApiGetInvoices = (data?:any)=>{
  return baseApiCall({
    url: getInvoices + data,
    method: 'get',
  })
}


export const ApiGetDealerDashboard = (data?:any)=>{
  return baseApiCall({
    url: getDealerDashboard + data,
    method: 'get',
  })
}


export const ApiCreatePayment = (data:any)=>{
  return baseApiCall({
    url: createPayment,
    method: 'post',
    data
  })
}


